<template>
  <NavBar :progress="30" titleSuffix="tevredenheidsonderzoek" customBase="vragenlijst/" />
  <div class="outer-container">
    <router-link :to="{ name: 'SurveySatisfied', params: { 'opticienId': $route.params.opticienId, 'companyId': $route.params.companyId } }">
      <img class="arrow-back" alt="arrow" src="../../assets/arrow-left.svg">
    </router-link>
    <div class="question">
      <div class="content-title">
        3 / 10
      </div>
<!--      Has used other glasses before-->
      <scale-question
        v-if="getUsedOther()"
        :selected-value="getWorkingPosition()"
        @update:selectedValue="selectedValue"
        lowQuote="Ik merk geen verschil"
        highQuote="Ja, veel beter <i>met deze.</i>"
      >
        Heb jij met deze <i>nieuwe</i> beeldschermbril een<br/>
        meer ontspannen werkhouding dan <i>met je</i><br/>
        <i>andere beeldschermbril?</i>
      </scale-question>
<!--      Not used other glasses before -->
      <scale-question
        v-if="!getUsedOther()"
        :selected-value="getWorkingPosition()"
        @update:selectedValue="selectedValue"
        lowQuote="Ik merk geen verschil"
        highQuote="Ja, veel beter <i>met deze.</i>"
      >
        Heb jij <i>met</i> je beeldschermbril een meer<br/>
        ontspannen werkhouding dan <i>zonder</i>?
      </scale-question>
    </div>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import ScaleQuestion from "@/components/ScaleQuestion";
  import {createNamespacedHelpers} from "vuex";
  const {mapGetters, mapMutations} = createNamespacedHelpers('survey');

  export default {
    name: "WorkingPosition",
    components: {
      ScaleQuestion,
      NavBar
    },
    methods: {
      ...mapGetters(["getUsedOther", "getSatisfied", "getWorkingPosition"]),
      ...mapMutations(["setWorkingPosition"]),
      selectedValue(newValue) {
        this.setWorkingPosition(newValue);
        this.$router.push(
          {
            name: 'SurveyTiredEyes',
            params: {
              'opticienId': this.$route.params.opticienId,
              'companyId': this.$route.params.companyId
            }
          }
        );
      }
    },
    created() {
      // Navigate back when no previous answer found.
      if (this.getSatisfied() === undefined) this.$router.push(
          {
            name: 'SurveySatisfied',
            params: {
              'opticienId': this.$route.params.opticienId,
              'companyId': this.$route.params.companyId
            }
          }
      );
    }
  }
</script>

<style scoped>
  .content-title {
    font-weight: bold;
  }

  .question {
    margin-top: 8rem;

    display: inline-flex;
    flex-direction: column;
    gap: 1.5rem;
  }
</style>